import { PERMISSION_DOMAINS, PERMISSION_ROLES } from '@repo/domain';

import type { RolePermissions } from '@features/auth/types';
import { buildRolePermissions } from '@features/auth/utils/buildRolePermissions';

/** What every role of the copied permission contract carries. */
export const ROLE_PERMISSIONS: RolePermissions = buildRolePermissions(
  PERMISSION_ROLES,
  Object.values(PERMISSION_DOMAINS)
);
